import type { FileDownloadResponse, LiquidationAggregation } from "types";
import { readJsonFromStorage } from "./files";

const DETAIL_COLLECTIONS = [
  "liquidation_settlement_types",
  "liquidation_clients",
  "liquidation_containers",
  "liquidation_articles",
  "liquidation_article_locations",
  "liquidation_article_location_log",
  "liquidation_movement_articles",
  "liquidation_additional_items",
  "liquidation_movement_additional_items",
  "liquidation_movements",
] as const;

function isLiquidationDetail(value: unknown): value is LiquidationAggregation {
  if (!value || typeof value !== "object" || Array.isArray(value)) return false;

  const detail = value as Partial<LiquidationAggregation>;
  const settlementTypes = detail.liquidation_settlement_types;
  return Number.isSafeInteger(detail.id) && Number(detail.id) > 0 &&
    Number.isSafeInteger(detail.client_id) && Number(detail.client_id) > 0 &&
    typeof detail.date_from === "string" && Number.isFinite(Date.parse(detail.date_from)) &&
    typeof detail.date_to === "string" && Number.isFinite(Date.parse(detail.date_to)) &&
    typeof detail.total === "number" && Number.isFinite(detail.total) &&
    typeof detail.subtotal_adicionales === "number" && Number.isFinite(detail.subtotal_adicionales) &&
    typeof detail.store_description === "string" &&
    DETAIL_COLLECTIONS.every((field) => Array.isArray(detail[field])) &&
    typeof detail.liquidation_clients?.[0]?.razon_social === "string" &&
    Array.isArray(settlementTypes) && settlementTypes.length >= 3 &&
    settlementTypes.slice(0, 3).every(
      (settlementType) => settlementType != null &&
        typeof settlementType.subtotal === "number" && Number.isFinite(settlementType.subtotal),
    ) &&
    (detail.child_liquidations === undefined ||
      (Array.isArray(detail.child_liquidations) && detail.child_liquidations.every(isLiquidationDetail)));
}

export async function readLiquidationDetails(
  download: FileDownloadResponse,
  id: number,
): Promise<LiquidationAggregation[]> {
  if (!Number.isSafeInteger(id) || id <= 0) {
    throw new Error("El identificador de la liquidacion debe ser un entero positivo seguro.");
  }

  const detail = await readJsonFromStorage(download);

  if (!Array.isArray(detail) || detail.length !== 1 ||
    !isLiquidationDetail(detail[0]) || detail[0].id !== id) {
    throw new Error("El JSON obtenido no contiene el detalle valido de la liquidacion solicitada.");
  }

  return detail;
}
